import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  ChangeCompanyBoardInArticlesOfAssociation,
  ChangeCompanyBoardInArticlesOfAssociationForm,
} from "./changeCompanyBoardInArticlesOfAssociationDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeCompanyBoardInArticlesOfAssociation>,
  data?: ChangeCompanyBoardInArticlesOfAssociation,
): ChangeCompanyBoardInArticlesOfAssociationForm {
  return new ChangeCompanyBoardInArticlesOfAssociationForm(dispatch, context, data);
}

export function applyForm(
  form: ChangeCompanyBoardInArticlesOfAssociationForm,
): ChangeCompanyBoardInArticlesOfAssociation {
  return {
    type: DecisionType.changeCompanyBoardInArticlesOfAssociation,
    paragraph: form.paragraph.selected,
    texts: form.texts.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
  };
}

export function handleEvent(form: ChangeCompanyBoardInArticlesOfAssociationForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function validate(form: ChangeCompanyBoardInArticlesOfAssociationForm) {
  return form.validate();
}

export function isValid(form: ChangeCompanyBoardInArticlesOfAssociationForm) {
  return form.isValid;
}

export const changeCompanyBoardInArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.changeCompanyBoardInArticlesOfAssociation,
  ChangeCompanyBoardInArticlesOfAssociation,
  ChangeCompanyBoardInArticlesOfAssociationForm
> = {
  type: DecisionType.changeCompanyBoardInArticlesOfAssociation,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
